import { render, staticRenderFns } from "./Receipt-addProduct.vue?vue&type=template&id=0ae0174a"
import script from "./Receipt-addProduct.vue?vue&type=script&lang=js"
export * from "./Receipt-addProduct.vue?vue&type=script&lang=js"
import style0 from "./Receipt-addProduct.vue?vue&type=style&index=0&id=0ae0174a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports